import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home: React.FC = () => {
  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <h1>Welcome to Guyana Oil & Gas</h1>
            <p>
              Your comprehensive resource for Guyana's thriving oil and gas industry. 
              Discover the latest news, opportunities, and insights from one of the world's 
              fastest-growing energy sectors.
            </p>
            <div className="hero-buttons">
              <Link to="/news" className="btn btn-primary">Latest News</Link>
              <Link to="/vacancies" className="btn btn-outline">View Opportunities</Link>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-item">
              <h3>11+ Billion</h3>
              <p>Barrels of Oil Reserves</p>
            </div>
            <div className="stat-item">
              <h3>600,000+</h3>
              <p>Barrels Per Day Production</p>
            </div>
            <div className="stat-item">
              <h3>30+</h3>
              <p>Major Discoveries</p>
            </div>
            <div className="stat-item">
              <h3>5+</h3>
              <p>Active Development Projects</p>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features">
        <div className="container">
          <h2 className="section-title">Explore Our Resources</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">📰</div>
              <h3>Latest News</h3>
              <p>Stay updated with the latest developments in Guyana's oil and gas sector from Oil Now and other reliable sources.</p>
              <Link to="/news" className="btn btn-secondary">Read News</Link>
            </div>

            <div className="feature-card">
              <div className="feature-icon">💼</div>
              <h3>Job Opportunities</h3>
              <p>Discover exciting career opportunities in Guyana's oil and gas industry. Apply directly or get redirected to company websites.</p>
              <Link to="/vacancies" className="btn btn-secondary">View Jobs</Link>
            </div>

            <div className="feature-card">
              <div className="feature-icon">📚</div>
              <h3>Industry History</h3>
              <p>Learn about the remarkable journey of Guyana's oil and gas sector from discovery to production.</p>
              <Link to="/history" className="btn btn-secondary">Explore History</Link>
            </div>

            <div className="feature-card">
              <div className="feature-icon">🛢️</div>
              <h3>Oil Reserves</h3>
              <p>Explore Guyana's vast oil reserves, key companies, and understand oil ownership structure.</p>
              <Link to="/reserves" className="btn btn-secondary">View Reserves</Link>
            </div>

            <div className="feature-card">
              <div className="feature-icon">🏗️</div>
              <h3>Contractors & Resources</h3>
              <p>Find contractors, service providers, and resources for Guyana's oil and gas operations.</p>
              <Link to="/contractors" className="btn btn-secondary">Browse Contractors</Link>
            </div>

            <div className="feature-card">
              <div className="feature-icon">🌍</div>
              <h3>Industry Impact</h3>
              <p>Understand the economic, social, and environmental impact of Guyana's oil and gas development.</p>
              <Link to="/history" className="btn btn-secondary">Learn More</Link>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="about">
        <div className="container">
          <div className="about-content">
            <div className="about-text">
              <h2>About Guyana's Oil & Gas Sector</h2>
              <p>
                Guyana has emerged as one of the most exciting oil and gas frontiers in the world. 
                Since the first major discovery in 2015, the country has experienced unprecedented 
                growth in its energy sector, with production reaching over 600,000 barrels per day 
                and proven reserves exceeding 11 billion barrels.
              </p>
              <p>
                Our platform serves as a comprehensive resource for industry professionals, 
                investors, and anyone interested in Guyana's oil and gas sector. We provide 
                up-to-date information, job opportunities, and insights to help you navigate 
                this dynamic industry.
              </p>
              <div className="about-highlights">
                <div className="highlight">
                  <strong>World-Class Discoveries:</strong> Multiple major discoveries in the Stabroek Block
                </div>
                <div className="highlight">
                  <strong>Rapid Development:</strong> Fast-track development from discovery to production
                </div>
                <div className="highlight">
                  <strong>Global Partnerships:</strong> Collaboration with leading international oil companies
                </div>
              </div>
            </div>
            <div className="about-image">
              <div className="image-placeholder">
                <span>Guyana Offshore Operations</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Explore Guyana's Oil & Gas Industry?</h2>
            <p>Start your journey by exploring our comprehensive resources and stay informed about the latest developments.</p>
            <div className="cta-buttons">
              <Link to="/news" className="btn btn-primary">Get Started</Link>
              <Link to="/contractors" className="btn btn-outline">Find Services</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
